import { Button, Col, DatePicker, Modal, Row, Select } from 'antd'
import { cloneDeep, get, orderBy } from 'lodash'
import moment from 'moment'
import { useEffect, useState } from 'react'
import {
  PLAN_STATUS_ACTIONS,
  PLAN_STATUS_ACTIONS_UPDATER,
} from './SetStatusDialog.constant'
import './SetStatusDialog.style.less'
import { isEmptyValue, titleCase } from '@/utils/common'
import { currentSelectedCollaborator } from '@/jotai/order.jotai'
import { useAuth } from '@/providers/auth.provider'
import { useAtom } from 'jotai'

interface Prop {
  current_status: string
  visible: boolean
  onClose: (e: any) => any
  onApprovalChange: (status: string, actualDate: any) => any
  data: any
  fieldName: string
}
// planned start, approved, rejected, submitted
const { Option: SelectOption } = Select

function SetStatusDialog(props: Prop) {
  const { current_status, visible, onClose, onApprovalChange, data } = props

  const [approvalStatusListFilter, setapprovalStatusListFilter] = useState([])

  const [stateApproval, setStateApproval] = useState(undefined)

  const [selectedActualDate, setSelectedActualDate] = useState(moment())

  const [changes, setchanges] = useState(false)

  const [currentCollaborator] = useAtom(currentSelectedCollaborator)
  const { user } = useAuth()

  const IsAssignedAndIsUpdater = () => {
    const isUserIsCollaborator = currentCollaborator?.find(
      (collaborator) => collaborator?.user?.id === user?.id
    )
    const currentUserAssigned = props.data.assignments?.find(
      (assignment) => assignment?.user?.id === isUserIsCollaborator?.user.id
    )
    return (
      currentUserAssigned?.user?.id == user?.id &&
      isUserIsCollaborator.roles?.role === 'updater'
    )
  }

  useEffect(() => {
    const activities = orderBy(data?.activities, ['created_date'], ['desc'])
    if (!isEmptyValue(activities)) {
      setSelectedActualDate(
        moment(activities[0]?.json_value?.actual_date ?? new Date())
      )
    } else {
      setSelectedActualDate(moment)
    }
  }, [])

  useEffect(() => {
    setapprovalStatusListFilter(
      get(
        cloneDeep(
          IsAssignedAndIsUpdater()
            ? PLAN_STATUS_ACTIONS_UPDATER
            : PLAN_STATUS_ACTIONS
        ),
        data.type,
        []
      )
    )
    setStateApproval(current_status)
  }, [current_status])

  const onClickSave = (e) => {
    if (!stateApproval) return
    onApprovalChange(stateApproval, selectedActualDate)
    onClose(e)
  }

  return (
    <Modal
      title={props.fieldName}
      open={visible}
      onCancel={onClose}
      className="dialog-set-plan modal-change-task-status"
      footer={[
        <Button
          className="dialog-cancel-button default-dialog-button"
          key="cancel"
          type="primary"
          size="large"
          shape="round"
          onClick={onClose}
        >
          Cancel
        </Button>,
        <Button
          className="default-dialog-button"
          key="submit"
          type="primary"
          shape="round"
          size="large"
          onClick={onClickSave}
          disabled={isEmptyValue(selectedActualDate) || !changes}
        >
          Save
        </Button>,
      ]}
    >
      {/* current_status */}
      <Row gutter={[16, 0]} align={'middle'}>
        <Col md={6} lg={6}>
          <label style={{ fontWeight: '500' }}>Status</label>
        </Col>
        <Col md={18} lg={18}>
          <div
            className="set-status-selector"
            style={{ minHeight: '32px !important', height: '32px !important' }}
          >
            <Select
              value={stateApproval}
              className="set-status-selector"
              style={{ width: '100%', minHeight: '32px !important' }}
              onChange={(value) => {
                setStateApproval(value)
                setSelectedActualDate(null)
                setchanges(true)
              }}
            >
              {approvalStatusListFilter.length > 0 &&
                approvalStatusListFilter.map((op, i) => {
                  return (
                    <SelectOption key={i} value={op}>
                      {titleCase(op)}
                    </SelectOption>
                  )
                })}
            </Select>
          </div>
          {!stateApproval && (
            <div className="ant-form-item-explain ant-form-item-explain-error">
              <div
                role="alert"
                style={{ fontSize: '14px', fontWeight: '600' }}
              >{`Please Select Status.`}</div>
            </div>
          )}
        </Col>
      </Row>
      <Row gutter={[16, 0]} align={'middle'} style={{ marginTop: 15 }}>
        <Col md={6} lg={6}>
          <label style={{ fontWeight: '500' }}>Actual Date</label>
        </Col>
        <Col md={18} lg={18}>
          <div
            className="set-status-selector"
            style={{ minHeight: '32px !important', height: '32px !important' }}
          >
            <DatePicker
              className={'br-1'}
              autoFocus
              allowClear={false}
              style={{ width: '100%' }}
              placeholder={'Select a date'}
              value={selectedActualDate}
              format="DD MMM YYYY"
              onChange={(value: moment.Moment) => {
                setSelectedActualDate(value)
              }}
            />
          </div>
          {!stateApproval && (
            <div className="ant-form-item-explain ant-form-item-explain-error">
              <div
                role="alert"
                style={{ fontSize: '14px', fontWeight: '600' }}
              >{`Please Select Status.`}</div>
            </div>
          )}
        </Col>
      </Row>
    </Modal>
  )
}

export default SetStatusDialog
